export enum ProviderInvoiceStateEnum {
  open = 1,
  closed = 2,
  printed = 3,
  paid = 4
}
